/**
 * Ícones de redes/site no rodapé da sidebar — montados a partir do site_config
 * da empresa ativa (o MESMO que o cliente preenche em "Redes & Site" no BI do
 * Site). Cada cliente vê os próprios links; sem nada configurado, o bloco não
 * aparece.
 *
 * Saiu de `Layout.tsx` em 26/08 (R2): o Layout está no inventário do portão de
 * tamanho — pode encolher, não pode crescer — e o R2 precisava de duas linhas
 * lá (o gancho da pele da rota). Capacidade nova entra por EXTRAÇÃO: este
 * ajudante é puro e não tinha por que morar num componente de 1.000 linhas.
 */
import { Facebook, Globe, Instagram, Linkedin, Mail, MessageCircle } from "lucide-react";

export type SiteCfg =
  | {
      site_url?: string;
      instagram?: string;
      facebook?: string;
      linkedin?: string;
      whatsapp?: string;
      email_url?: string;
    }
  | null
  | undefined;

export function canaisDe(cfg: SiteCfg): { href: string; label: string; icon: typeof Globe }[] {
  if (!cfg) return [];
  const out: { href: string; label: string; icon: typeof Globe }[] = [];
  const add = (v: string | undefined, label: string, icon: typeof Globe) => {
    if (v && v.trim()) out.push({ href: /^https?:\/\//.test(v) ? v : `https://${v}`, label, icon });
  };
  add(cfg.site_url, "Site", Globe);
  add(cfg.instagram, "Instagram", Instagram);
  add(cfg.facebook, "Facebook", Facebook);
  add(cfg.linkedin, "LinkedIn", Linkedin);
  add(cfg.email_url, "E-mail", Mail);
  if (cfg.whatsapp && cfg.whatsapp.trim())
    out.push({
      href: `https://wa.me/${cfg.whatsapp.replace(/\D/g, "")}`,
      label: "WhatsApp",
      icon: MessageCircle,
    });
  return out;
}
